<template>
    <div id="triggerContainer" class="align-items-center">
        <CRow v-on:click="toTriggerHitAlerts">
            <CCol col="3"  class="nopadding">
                <CWidgetIcon :header="totalAlerts" :height="20"
                             text="Alerts"
                             color="primary" class="nomargin1">
                    <CIcon name="cil-bell" />
                </CWidgetIcon>
            </CCol>
            <CCol col="3" class="nopadding">
                <CWidgetIcon :header="defaultDeadlineAlerts" 
                             text="Deadline"
                             color="primary" class="nomargin2">
                    <CIcon name="cil-warning" />
                </CWidgetIcon>
            </CCol>

            <CCol col="3" class="nopadding" >
                <CWidgetIcon :header="hitTriggerAlerts" 
                             text="Hit Triggers"
                             color="primary" class="nomargin3">
                    <CIcon name="cil-warning" />
                </CWidgetIcon>
            </CCol>
            <CCol col="3" class="nopadding">
                <CWidgetIcon :header="triggerStatusAlerts" 
                             text="Trigger status"
                             color="primary" class="nomargin4">
                    <CIcon name="cil-warning" />
                </CWidgetIcon>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from 'vue';
    import apis from '@/common/network';

    export default Vue.extend({
        created() {
            this.fetchAlertsData()
        },
        data() {
            return {
                totalAlerts: "-",
                hitTriggerAlerts: "-",
                triggerStatusAlerts: "-",
                defaultDeadlineAlerts: "-",
            }
        },
        methods: {
            fetchAlertsData() {
                apis.protectedApi("TriggerAlert/GroupCounts").then(gc => {
                    this.hitTriggerAlerts = gc.data.hit.toString();
                    this.triggerStatusAlerts = gc.data.status.toString();
                    this.defaultDeadlineAlerts = gc.data.deadline.toString();
                    this.totalAlerts = (gc.data.hit + gc.data.status + gc.data.deadline).toString();
                }
                ).catch(
                    //response => { this.handleError(response); }
                );
            },
            toTriggerHitAlerts(args) {
                this.$router.push({ name: 'Hit Triggers' });
            },
            toStatusAlerts(args) {
                this.$router.push({ name: 'Trigger Status' });
            },
            toDeadlineAlerts(args) {
                this.$router.push({ name: 'Default Deadlines' });
            },
            toAlerts(args) {
                this.$router.push({ name: 'Alerts' });
            },
        }
    })
</script>

<style scoped>
    .nopadding {
        padding: 0px 0px 0px 0px !important;
    }
    .nomargin2, .nomargin3 {
        margin: 0px 0px 0px 0px !important;
        padding: 9px !important;
        border: 0px solid !important;
        border-radius: 0rem;
        height: 185px;
    }
    .nomargin1 {
        margin: 0px 0px 0px 0px !important;
        padding: 9px !important;
        border: 0px solid !important;
        border-top-left-radius: 0.25rem;
        border-bottom-left-radius: 0.25rem;
        border-top-right-radius: 0rem;
        border-bottom-right-radius: 0rem;
        height: 185px;
    }
    .nomargin4 {
        margin: 0px 0px 0px 0px !important;
        padding: 8px !important;
        border: 0px solid !important;
        border-top-right-radius: 0.25rem;
        border-bottom-right-radius: 0.25rem;
        border-top-left-radius: 0rem;
        border-bottom-left-radius: 0rem;
        height: 185px;
    }


    #triggerContainer {
        width: 100%;
        padding: 0px 33px 0px 0px;
    }

</style>